import { Pipe, PipeTransform } from '@angular/core';
import {find} from 'lodash-es';
import {RoleList} from '../../generated/sales-terminal-client';

@Pipe({
  name: 'roles'
})
export class RolesPipe implements PipeTransform {
  constructor() {}

  transform (value: any[] = [], roles: RoleList[] = []) {
    return value.map(id => {
      const role = find(roles, {roleId: id});
      return role && role.name || id;
    }).join(', ');
  }
}
